import React, { Fragment } from 'react';

import FlashMessage from 'buyside/components/presentation/FlashMessage/flashMessage';
import MessageIndexCard from './MessageIndexCard/MessageIndexCard';
import MessageIndexPaginationButton from './MessageIndexPaginationButton/MessageIndexPaginationButton';
import PaginatedIndex, {
  PaginatedIndexItems
} from 'buyside/components/presentation/Index/paginatedIndex';
import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

const messageRenderer = isMobile => (message, idx) => (
  <MessageIndexCard key={idx} message={message} isMobile={isMobile} />
);

const MessagesIndexArea = ({ messages, hasNextPage, fetchNextPage }) => {
  const isMobile = useIsMobile();

  if (messages.length === 0) {
    // no messages, render flash message
    return (
      <Fragment>
        <FlashMessage>There are no messages to display</FlashMessage>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <PaginatedIndex
        indexItems={messages}
        indexItemRenderer={messageRenderer(isMobile)}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
      >
        <PaginatedIndexItems />
        <MessageIndexPaginationButton />
      </PaginatedIndex>
    </Fragment>
  );
};

export default MessagesIndexArea;
